

require('smoothscroll-polyfill').polyfill();

export default function (e) {
  e.preventDefault()
  const id = e.currentTarget.getAttribute('href').slice(1);
  window.scroll({
    top: document.getElementById(id).offsetTop,
    behavior: 'smooth'
  })
}
